import React, { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function ResetPassword() {
  const [password, setPassword] = useState('')
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const tokenHash = params.get('token_hash')
    const type = params.get('type')
    if (tokenHash && type) {
      supabase.auth.verifyOtp({ token_hash: tokenHash, type })
        .then(({ error }) => {
          if (error) setMessage('Σφάλμα: ' + error.message)
          else setReady(true)
        })
    } else {
      setReady(true)
    }
  }, [])

  const handleReset = async () => {
    if (!password) return
    setLoading(true)
    const { error } = await supabase.auth.updateUser({ password })
    if (error) {
      setMessage('Σφάλμα: ' + error.message)
      setLoading(false)
    } else {
      setMessage('Ο κωδικός άλλαξε!')
      setTimeout(() => { window.location.href = '/auth' }, 2000)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-logo">🎹</div>
      <div className="auth-title" style={{ color: 'var(--text)' }}>Νέος Κωδικός</div>
      <div className="auth-form">
        <input className="input" type="password" placeholder="Νέος κωδικός" value={password} onChange={e => setPassword(e.target.value)} />
        {message && <div style={{ color: message.includes('Σφάλμα') ? 'red' : 'green', textAlign: 'center', padding: '8px' }}>{message}</div>}
        {!ready && !message && <div style={{ textAlign: 'center', color: 'gray' }}>Επαλήθευση...</div>}
        <button className="btn-primary" onClick={handleReset} disabled={loading || !password || !ready}>
          {loading ? '...' : 'Αλλαγή Κωδικού'}
        </button>
      </div>
    </div>
  )
}
